import { Component, OnInit } from '@angular/core';
import {Student} from '../../model/student';
import {AppSettings} from '../../../app-settings';
import {ActivatedRoute} from '@angular/router';
import {DataManagementService} from '../../services/data-management.service';
import {AuthenticationService} from '../../services/authentication.service';
import {Constants} from '../../constants';
import {Subject} from 'rxjs';
import {AccessService} from '../../services/access.service';

@Component({
  selector: 'app-registration-reports',
  templateUrl: './registration-reports.component.html',
  styleUrls: ['./registration-reports.component.css']
})
export class RegistrationReportsComponent implements OnInit {
  dtTrigger: Subject<string> = new Subject();
  dtOptions: DataTables.Settings = {};
  filter_id;
  title;
  token;
  students: Student[];
  outgoingTerm;
  outgoingTermId = '0';
  downloadOutgoingStudentRegistrationStatusExcel = AppSettings.DOWNLOAD_OUTGOING_STUDENT_REGISTRATION_STATUS;
  downloadOutgoingStudentRankExcel = AppSettings.DOWNLOAD_OUTGOING_STUDENT_RANKS;
  selectUndefinedOptionValue = '0';
  outgoingStudents = [];
  errorMessage;

  constructor(private route: ActivatedRoute,
              private dmService: DataManagementService,
              private authenticationService: AuthenticationService,
              private accessService: AccessService) { }

  getOutgoingStudentRegistrationStatus(): void {
    this.dmService.getOne(Constants.STUDENT_REGISTRATION_STATUS, this.outgoingTermId)
        .subscribe(
            response => {
              if (response.status === 'success') {
                if (response.data.hasOwnProperty('message')) {
                  this.errorMessage = response.data.message;
                }
                this.outgoingStudents = response.data;
                if (this.outgoingStudents.length === 0) {
                  this.errorMessage = 'There is no data available for Student Registration status.';
                } else {
                  this.dtTrigger.next();
                }
              } else if (response.status === 'fail') {
                if (response.data.hasOwnProperty('message')) {
                  this.errorMessage = response.data.message;
                } else {
                  this.errorMessage = 'Something went wrong. Please contact support team';
                }
              }
            },
            error => {
              console.log(error);
              this.errorMessage = 'Server Error';
              // this.errorMessage = error;
            });
  }

  getOutgoingStudentRanks(): void {
    this.dmService.getOne(Constants.STUDENT_RANK, this.outgoingTermId)
        .subscribe(
            response => {
              if (response.status === 'success') {
                if (response.data.hasOwnProperty('message')) {
                  this.errorMessage = response.data.message;
                }
                this.outgoingStudents = response.data;
                if (this.outgoingStudents.length === 0) {
                  this.errorMessage = 'There is no data available for Student Ranks.';
                } else {
                  this.dtTrigger.next();
                }
              } else if (response.status === 'fail') {
                if (response.data.hasOwnProperty('message')) {
                  this.errorMessage = response.data.message;
                } else {
                  this.errorMessage = 'Something went wrong. Please contact support team';
                }
              }
            },
            error => {
              console.log(error);
              this.errorMessage = 'Server Error';
              // this.errorMessage = error;
            });
  }

  getAllTerms() {
    this.dmService.getAll(Constants.TERM_SETTINGS)
        .subscribe(
            response => {
              if (response.status === 'success') {
                this.outgoingTerm = response.data.outgoing_terms;
                if (this.outgoingTerm.length > 0) {
                  this.outgoingTermId = this.outgoingTerm[0].outgoing_term_id;
                }
              } else if (response.status === 'fail') {
                if (response.data.hasOwnProperty('message')) {
                  this.errorMessage = response.data.message;
                } else {
                  this.errorMessage = 'Something went wrong. Please contact support team';
                }
              }
            },
            error => {
              console.log(error);
              this.errorMessage = 'Server Error';
              // this.errorMessage = error;
            });
  }

  termChange() {
    if (this.filter_id === 1) {
      this.getOutgoingStudentRegistrationStatus();
    } else if (this.filter_id === 2) {
      this.getOutgoingStudentRanks();
    }
  }
    canAccessOIA() {
        return this.accessService.canAccessOIA();
    }

    canAccessEC() {
        return this.accessService.canAccessEC();
    }

  ngOnInit() {
    this.getAllTerms();
    this.token = '?token=' + this.authenticationService.getToken();
    this.route
        .params
        .subscribe(params => {
          this.filter_id = parseInt(params['id'], 10);
        });
    if (this.filter_id === 1) {
      this.title = 'Student Registrations along with the status from OIA ';
      this.getOutgoingStudentRegistrationStatus();
    } else if (this.filter_id === 2) {
      this.title = 'Students Report';
      this.getOutgoingStudentRanks();
    }
    this.dtOptions = {
      paging: true,
      retrieve: true,
      destroy: true,
      lengthChange: true,
      info: false
    };
  }

}
